export default function SectionRail({ index, label }) {
  return (
    <div className="hidden lg:flex flex-col items-start gap-3 pr-6">
      <span className="font-mono-plex text-[0.7rem] tracking-[0.16em] text-muted-foreground uppercase">
        {index}
      </span>
      <span className="h-16 w-px bg-border" aria-hidden="true" />
      <span className="font-mono-plex text-[0.68rem] tracking-[0.16em] text-muted-foreground uppercase">
        {label}
      </span>
    </div>
  );
}
